module.exports = __webpack_public_path__ + "media/es_slide29_muntatge_ensamblatge.44ce5e7d.mp4";